import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

import { checkForAppUpdate, setAppUpdateRegistration } from '@/lib/appUpdate'

const CHECK_INTERVAL_MS = 60_000

export function useAppUpdater() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return
      setAppUpdateRegistration(registration)

      const intervalId = setInterval(checkForAppUpdate, CHECK_INTERVAL_MS)

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          checkForAppUpdate()
        }
      })

      return () => clearInterval(intervalId)
    },
  })

  useEffect(() => {
    if (needRefresh) {
      updateServiceWorker(true)
    }
  }, [needRefresh, updateServiceWorker])
}
